import type { RouteLocationNormalized } from 'vue-router';

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized) => {
  // 🚨 MIDDLEWARE TEMPORAIREMENT DÉSACTIVÉ pour le debug des cookies admin
  console.log('🔵 [AUTH MIDDLEWARE] Désactivé temporairement');
  return;

  /* MIDDLEWARE ORIGINAL DÉSACTIVÉ
  const jwtCookie = useCookie('token');
  const refreshCookie = useCookie('refreshToken');
  const userStore = useUserStore();
  const config = useRuntimeConfig();
  const siteType = config.public.frontMode;

  function decodeJwt(token: string): any | null {
    try {
      const parts = token.split('.');
      if (parts.length !== 3) {
        return null;
      }
      const payload = parts[1];
      let decodedPayload: string;
      if (process.server) {
        decodedPayload = Buffer.from(payload, 'base64').toString('utf8');
      } else {
        decodedPayload = atob(payload);
      }
      return JSON.parse(decodedPayload);
    } catch (error) {
      console.error('Erreur lors du décodage du JWT:', error);
      return null;
    }
  }

  async function resetAuthConfig() {
    try {
      await fetch('/api/auth/reset-config', { method: 'POST' });
      console.info('[Auth] Reset auth configuration.');
    } catch (error) {
      console.error('[Auth] Failed to reset auth config:', error);
    }
  }

  async function checkAuthOnServer() {
    console.log('checkAuthOnServer jwtCookie', jwtCookie.value);
    console.log('checkAuthOnServer refreshCookie', refreshCookie.value);
    const validateJwt = (token: string) => {
      if (!token) return false;
      const decoded = decodeJwt(token);
      return decoded?.exp && Date.now() / 1000 < decoded.exp;
    };
    return false;  
  }

  const isAuthenticated = await checkAuthOnServer();
  userStore.isAuthenticated = isAuthenticated;
  useCookie('isAuthenticated').value = isAuthenticated;
  const loginPath = '/auth/login';
  const isAuthPage = [
    '/auth/login',
    '/auth/register',
    '/auth/forgot-password',
    '/auth/reset-password',
  ].includes(to.path);
  const homePath = '/';
  */
});
